export * from './SectionHeading.styles';
